<script lang="ts">
  import TextNew from "../TextNew.svelte";

  export let name: string;
  export let phoneNumber: string;
</script>

<div class="container">
  <TextNew size="s" --line-height="var(--rk-line-height-m)">
    {name}
  </TextNew>
  <TextNew size="s" --line-height="var(--rk-line-height-m)" --rk-text-color="var(--rk-text-low)">
    {phoneNumber}
  </TextNew>
</div>

<style>
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0px;
    border-top: 1px solid var(--rk-divider-0);
  }
</style>
